import "./scss/base.scss"
import initFloorForm from "./pages/3d_podorysy/floor-form"
import { initForm as initDroneForm } from "./pages/virtualny_dron/form"
import initNav from "./components/nav/nav"
import initClientsSwiper from "./pages/home/clients_swiper"
import initPriceList from "./components/price_list"

const onReady = (fn) => {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fn)
  } else {
    fn()
  }
}

onReady(() => {
  initFloorForm()
  initDroneForm()
  initNav()
  initClientsSwiper()
  initPriceList()
})
